import React, { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { mapModuleToSectionOptions } from 'components/CustomFields/utils'

export default function SectionSelectForm ({ fieldName, label }) {
  const [options, setOptions] = useState([])

  const { t } = useTranslation()
  const { values } = useFormikContext()
  const module = values.module

  useEffect(() => {
    if (module) {
      setOptions(mapModuleToSectionOptions(module))
    }
  }, [module])

  return (
    <>
      <ControlledSelectField
        fieldName={fieldName}
        label={t(label)}
        options={options}
        getOptionValue={section => section.value}
        getOptionLabel={section => t(section.label)}
        disabled={!values.module}/>
    </>
  )
}
